import { Component, OnDestroy, ViewChild } from '@angular/core';
import { SubSink } from 'subsink';

import { ScriptsComponent } from '../scripts/scripts.component';

@Component({
  selector: 'app-scripts-settings',
  templateUrl: './scripts-settings.component.html',
  styleUrls: ['./scripts-settings.component.scss'],
})
export class ScriptsSettingsComponent implements OnDestroy {

  @ViewChild('appScripts') appScripts: ScriptsComponent;

  private subs = new SubSink();

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  openCreate() {
    this.appScripts.openCreate();
  }
}
